import { ReactionSocialPostEntity } from "@/modules/social/entities/socialEntity"
import type { ReactionSocialPostDto } from "@/modules/social/gateway/socialDto"

export class ReactionSocialPostEntityBuilder {
  private dto: ReactionSocialPostDto

  static create() {
    return new ReactionSocialPostEntityBuilder()
  }

  protected constructor() {
    this.dto = {
      myReaction: null,
      allGroupedReactions: [],
    }
  }

  withMyReaction(emoji: string): this {
    this.dto.myReaction = { emoji }
    return this
  }

  withGroupedReactions(reactions: { emoji: string; number: number }[]): this {
    this.dto.allGroupedReactions = reactions
    return this
  }

  build(): ReactionSocialPostEntity {
    return ReactionSocialPostEntity.fromDto(this.dto)
  }

  buildDto(): ReactionSocialPostDto {
    return this.dto
  }
}
